import { createWebSocketStore } from 'src/components/#services/helpers';
export const myNickname = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'profile_getNicknameChangePrice',
        agent: 'user',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
